import { render, staticRenderFns } from "./_base-user-request.vue?vue&type=template&id=f5ae5430&scoped=true"
import script from "./_base-user-request.vue?vue&type=script&lang=js"
export * from "./_base-user-request.vue?vue&type=script&lang=js"
import style0 from "./_base-user-request.vue?vue&type=style&index=0&id=f5ae5430&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5ae5430",
  null
  
)

export default component.exports